import type { AiCapabilityPage } from "../schema.js";
import { LIVE, ALL_ROLES } from "./_shared.js";

/**
 * `ACCT-NOTIFY` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/profile/notifications` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (QĐ PO 17/09 mục 12 — cụm tài khoản: tuỳ chọn thông báo; hai cửa `device-tokens` là đăng ký thiết bị nhận báo, do chính màn này bật/tắt).
 */
export const ACCT_NOTIFY = {
  id: "ACCT-NOTIFY",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  slots: [],
  llm: {
    description: "CÀI ĐẶT nhận thông báo: bật/tắt từng loại, chọn kênh. KHÔNG phải nơi ĐỌC các thông báo đã nhận.",
    examples: [
      "tắt thông báo",
      "tat thong bao",
      "chỉnh thông báo",
      "chinh thong bao",
      "đừng báo tôi mỗi lần có người đóng",
      "cài đặt thông báo",
      // ——— 0105: thêm cho đủ 40 ———
      "cai dat thong bao",
      "bật thông báo lại",
      "bat thong bao lai",
      "tắt báo đêm khuya",
      "tat bao dem khuya",
      "tôi không muốn nhận báo nữa",
      "toi khong muon nhan bao nua",
      "chỉnh xem loại nào thì báo cho tôi",
      "chinh xem loai nao thi bao cho toi",
      "app báo nhiều quá, chỉnh lại giúp",
      "app bao nhieu qua chinh lai giup",
      "tuỳ chọn thông báo",
      "tuy chon thong bao",
      "tắt báo nhắc đóng tiền",
      "tat bao nhac dong tien",
      "chỉ báo khi có khoản chi mới thôi",
      "chi bao khi co khoan chi moi thoi",
      "làm sao để bớt thông báo?",
      "lam sao de bot thong bao",
      "tắt hết báo của nhóm này",
      "tat het bao cua nhom nay",
      "bật báo khi ai đó đóng quỹ",
      "bat bao khi ai do dong quy",
      "cho tôi tắt tiếng thông báo",
      "cho toi tat tieng thong bao",
      "sửa cài đặt báo",
      "sua cai dat bao",
      "không nhận báo qua điện thoại nữa",
      "khong nhan bao qua dien thoai nua",
      "mở phần cài báo",
      "mo phan cai bao",
      "tôi muốn chọn kênh nhận báo",
      "chỉnh lại mấy cái báo trong app",
      "tuỳ chỉnh báo",
      "tat bot thong bao di",
    ],
  },
  screen: "/profile/notifications",
  screenShows: "notification_settings",
  endpoints: [
    "GET /me/notification-preferences",
    "PUT /me/notification-preferences",
    "POST /me/device-tokens",
    "DELETE /me/device-tokens",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở cài đặt thông báo của bạn nhé.",
  },
  journey: { after: ["NOTIF-INBOX"] },
  help: { title: "Cài đặt thông báo", tryNow: "tắt thông báo" },
} satisfies AiCapabilityPage;
